import { render, staticRenderFns } from "./124.vue?vue&type=template&id=27803a60&scoped=true&"
var script = {}
import style0 from "./124.vue?vue&type=style&index=0&id=27803a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27803a60",
  null
  
)

export default component.exports